import ClearIcon from "@mui/icons-material/Clear";
import { Box, Button, CircularProgress } from "@mui/material";
import TaskIconButton from "../../../components/common/TaskIconButton";
import { useNavigate } from "react-router-dom";


/**
 * ActionButtons component.
 *
 * This component renders two action buttons: one for submitting a task or creating a NAT gateway, and another for canceling the operation.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {function} props.onSubmit - A callback function that is called when the "Submit Task" button is clicked.
 * @param {function} props.onCreateGateway - A callback function that is called when the "Create Nat Gateway" button is clicked.
 * @param {boolean} props.natGatewayReady - Indicates whether the NAT gateway is ready for task submission.
 * @param {boolean} props.natGatewayLoading - Indicates whether the NAT gateway is currently being created.
 *
 * @returns {JSX.Element} - The JSX element for the action buttons component.
 */
const ActionButtons = ({ onSubmit, onCreateGateway, natGatewayReady, natGatewayLoading }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {natGatewayReady ? (
        <Button variant="outlined" color="primary" onClick={onSubmit} disabled={natGatewayLoading}>
          Create Task
        </Button>
      ) : (
        <Button
          variant="outlined"
          color="secondary"
          onClick={onCreateGateway}
          disabled={natGatewayLoading}
          startIcon={natGatewayLoading && <CircularProgress size={20} color="inherit" />}
        >
          {natGatewayLoading ? "Creating Gateway..." : "Create NAT Gateway"}
        </Button>
      )}
      <TaskIconButton color="error" text="Cancel" icon={<ClearIcon />} onClick={() => navigate("/tasks")} />
    </Box>
  );
};

export default ActionButtons;